import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

export function GetFormInvalidFields(form: UntypedFormGroup | UntypedFormArray): string[][] {
  const formControls: string[][] = [];
  const children = Object.keys(form.controls);

  children.forEach((key) => {
    const field = form.get(key);

    if (field.invalid) {
      if (field instanceof UntypedFormControl) {
        formControls.push([key]);
      } else if (field instanceof UntypedFormGroup || field instanceof UntypedFormArray) {
        const invalidChildren = GetFormInvalidFields(field);
        const invalidChildrenKeys = invalidChildren.map((child) => [
          key,
          ...child,
        ]);
        formControls.push(...invalidChildrenKeys);
      }
    }
  });

  return formControls;
}
